import clsx from 'clsx';
import React from 'react';

import { Comment, CommentableType } from '../../utils/backend-api/comments';
import CommentForm from './CommentForm';
import CommentFormHeader from './CommentFormHeader';

export default function CommentFormSection({
  comment,
  commentableId,
  commentableType,
  replyingTo,
  hideReplyForm,
  hideEditForm,
}: {
  comment?: Comment;
  commentableId: number;
  commentableType: CommentableType;
  replyingTo?: string;
  hideReplyForm?: () => void;
  hideEditForm?: () => void;
}) {
  const isEditing = !!comment;
  return (
    <div
      className={clsx('comment-form', {
        '--reply': !!replyingTo,
      })}
      style={{
        display: 'block', // Overriding hidden style used in Rails erb comments
      }}
    >
      <CommentFormHeader
        isEditing={isEditing}
        isReplyForm={!!replyingTo}
        hideReplyForm={hideReplyForm}
        hideEditForm={hideEditForm}
      />
      <div className="comment-body">
        <CommentForm
          comment={comment}
          commentableId={commentableId}
          commentableType={commentableType}
          replyingTo={replyingTo}
          hideReplyForm={hideReplyForm}
          hideEditForm={hideEditForm}
        />
      </div>
    </div>
  );
}
